import { createContext, ReactNode, useContext } from 'react'

import { useChainFeaturesContext } from '@/contexts/ChainFeaturesContext'
import { EmptyGovernance, GovernanceHook, useGovernance } from '@/hooks/useGovernance'

type WithChildren = {
  children?: ReactNode
}

const GovernanceContext = createContext<GovernanceHook>(EmptyGovernance)

const GovernanceProvider: React.FC<WithChildren> = ({ children }) => {
  const value = useGovernance()
  return <GovernanceContext.Provider value={value}>{children}</GovernanceContext.Provider>
}

export const WrapperGovernanceProvider: React.FC<WithChildren> = ({ children }) => {
  const { hasFeature } = useChainFeaturesContext()
  const isGovernanceEnabled = hasFeature('elections')
  return isGovernanceEnabled ? <GovernanceProvider>{children}</GovernanceProvider> : children
}

export const useGovernanceContext = () => useContext(GovernanceContext)
